module.exports = __webpack_public_path__ + "static/media/night_flight_sample_4.26f56d2b.jpg";